import cn from "classnames";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { FC, ReactNode } from "react";
import styled from "styled-components";

const StyledHeaderLinkNew = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  &.HeaderLinkNew_active {
    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 14px;
      right: 14px;
      height: 3px;
      background: ${({ theme }) => theme.colors.black};
    }

    .HeaderLinkNew__anchor {
      font-weight: bold;
    }
  }

  .HeaderLinkNew__anchor {
    padding: 7px 14px;

    font-weight: normal;
    font-size: 14px;
    line-height: 18px;

    color: ${({ theme }) => theme.colors.black};
    text-decoration: none;

    border-radius: 10px;
  }
`;

interface Props {
  children?: ReactNode;
  href: string;
}

const HeaderLinkNew: FC<Props> = ({ href, children }) => {
  const { asPath } = useRouter();
  const isActive = asPath.startsWith(href);

  return (
    <StyledHeaderLinkNew className={cn({ HeaderLinkNew_active: isActive })}>
      <Link href={href}>
        <a className="HeaderLinkNew__anchor">{children}</a>
      </Link>
    </StyledHeaderLinkNew>
  );
};

export { HeaderLinkNew };
